/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';
import ArticleNoteHeader from './ArticleNoteHeader';
import type Mithril from 'mithril';

export interface NoteInputAttrs extends ComponentAttrs {
	value: string | undefined;
	onChange: (value: string) => void;
	onSave?: () => void;
	onCancel?: () => void;
	/** Sizes the textarea to match the rendered note it replaces. */
	textHeight?: number;
	loading?: boolean;
}

export default class NoteInput<CustomAttrs extends NoteInputAttrs = NoteInputAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { value, onChange, onSave, onCancel, textHeight, loading } = this.attrs;

		return (
			<div className="NoteInput">
				<ArticleNoteHeader />
				<textarea
					className="FormControl"
					oninput={withAttr('value', onChange)}
					placeholder={app.translator.trans('glowingblue-orell-bookshelf.forum.article_note.placeholder')}
					value={value}
					style={textHeight ? { height: `${textHeight}px` } : undefined}
					oncreate={(vnode: Mithril.VnodeDOM) => $(vnode.dom).focus()}
				/>
				{onSave && (
					<Button className="Button Button--primary Button--icon hasIcon" onclick={onSave} loading={loading} icon="far fa-save">
						{app.translator.trans('glowingblue-orell-bookshelf.forum.article_note.save')}
					</Button>
				)}
				{onCancel && !loading && (
					<Button className="Button Button--secondary" onclick={onCancel}>
						{app.translator.trans('glowingblue-orell-bookshelf.forum.article_note.cancel')}
					</Button>
				)}
			</div>
		);
	}
}
